import * as React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Divider, Typography } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
// import BuyForm from "./buyformTypes/BuyForm";
import BuyOrderTypeTab from "./orderTab/BuyOrderTypeTab";
import SellOrderTypeTab from "./orderTab/SellOrderTypeTab";
import PropTypes from "prop-types";

const BuySellTab = React.memo((props) => {
	const { coinPrice, coinSymbol } = props;
	const [value, setValue] = React.useState("1");

	console.log(coinPrice);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	return (
		<Box sx={{ width: "100%", typography: "body1" }}>
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<TabList onChange={handleChange} aria-label="lab API tabs example">
						<Tab label="Buy" value="1" sx={{ color: "green" }} />
						<Tab label="Sell" value="2" sx={{ color: "red" }} />
					</TabList>
				</Box>
				<TabPanel value="1">
					<BuyOrderTypeTab coinPrice={coinPrice} coinSymbol={coinSymbol} />
				</TabPanel>
				<TabPanel value="2">
					<SellOrderTypeTab coinPrice={coinPrice} coinSymbol={coinSymbol} />
				</TabPanel>
			</TabContext>
		</Box>
	);
});

BuySellTab.propTypes = {
	window: PropTypes.func,
	coinPrice: PropTypes.string.isRequired,
	// coinSymbol: PropTypes.string.isRequired,
	// coinImage: PropTypes.string.isRequired,
};

export default BuySellTab;
